import { formatCurrency } from '@/utils'
import React from 'react'
import { HelpCircle } from 'lucide-react'
import { Tooltip } from '@nextui-org/react'

interface MetricCardProps {
  emoji: string
  label: string
  value: string | number | React.ReactNode
  max?: number
  className?: string
  tooltip?: React.ReactNode
}

export const MetricCard: React.FC<MetricCardProps> = ({ emoji, label, value, max, className = '', tooltip }) => {
  return (
    <div
      className={`bg-gradient-to-br from-white to-blue-100 rounded-lg p-4 shadow-lg flex items-center space-x-4 ${className}`}
    >
      <span className="text-4xl">{emoji}</span>
      <div className="flex-grow">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-blue-900">{label}</h3>
          {tooltip && (
            <Tooltip content={tooltip}>
              <HelpCircle className="w-4 h-4 cursor-help text-blue-900" />
            </Tooltip>
          )}
        </div>
        <div className="text-xl lg:text-2xl font-bold text-blue-700">
          {typeof value === 'number' ? formatCurrency(value) : value} {max ? ` / ${formatCurrency(max as number)}` : ''}
        </div>
      </div>
    </div>
  )
}
